export default '/src/assets/webgl/pedro_1/audios/outro.mp3'